import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import { forwardRef } from 'react';
import { themed } from '@indeed/ifl-css';
import { Close } from '@indeed/ifl-icons';
import { StyledNotificationBase, StyledNotificationBody, NotificationTitle, StyledNotificationIcon, StyledNotificationContent } from '../Alert/styles.js';
import { jsx } from '@emotion/react';
export { NOTIFICATION_TYPES as TOAST_TYPES } from '../Alert/types.js';
import { Button } from '../Button/Button.js';
import { LiveRegion } from '../LiveRegion/LiveRegion.js';
import { icons } from '../Alert/Alert.js';
import '../../utils/transition.js';
import '../../utils/styled.js';
import '../../constants/index.js';
import '../../utils/createResponsive.js';
import '../../utils/transparentize.js';
import '../Button/context.js';
import '../IndeedThemeProvider/hooks/useColorMode.js';
import '../IndeedThemeProvider/hooks/useColorModeAttribute.js';
import '../../hooks/useIsomorphicLayoutEffect.js';
import '../Spinner/Spinner.js';
import '@indeed/ihl-use-id';
import '../IconWrapper/IconWrapper.js';
import '../VisuallyHidden/VisuallyHidden.js';

const statuses = {
  info: {
    [`${StyledNotificationIcon}`]: {
      color: "foreground.status.info"
    },
    [`${NotificationTitle}`]: {
      color: "foreground.status.info"
    }
  },
  success: {
    [`${StyledNotificationIcon}`]: {
      color: "foreground.status.success"
    },
    [`${NotificationTitle}`]: {
      color: "foreground.status.success"
    }
  },
  warning: {
    [`${StyledNotificationIcon}`]: {
      color: "foreground.status.warning"
    },
    [`${NotificationTitle}`]: {
      color: "foreground.status.warning"
    }
  },
  critical: {
    [`${StyledNotificationIcon}`]: {
      color: "foreground.status.critical"
    },
    [`${NotificationTitle}`]: {
      color: "foreground.status.critical"
    }
  }
};
const StyledToast = /*#__PURE__*/themed(StyledNotificationBase, process.env.NODE_ENV === "production" ? {
  styleProps: ["status"],
  shouldForwardProp: prop => prop !== "status",
  target: "e171e7gg0"
} : {
  styleProps: ["status"],
  shouldForwardProp: prop => prop !== "status",
  target: "e171e7gg0",
  label: "StyledToast"
})(_ref => {
  let {
    status = "info"
  } = _ref;
  return {
    display: "flex",
    alignItems: "flex-start",
    overflowWrap: "anywhere",
    columnGap: 1,
    paddingBlockStart: 4,
    paddingBlockEnd: 4,
    paddingInlineStart: 4,
    paddingInlineEnd: 4,
    inlineSize: "100%",
    maxInlineSize: "380px",
    color: "foreground.strong",
    bg: "background",
    borderRadius: "lg",
    boxShadow: "medium",
    ...statuses[status],
    [`${StyledNotificationBody}`]: {
      flex: "1 1 auto",
      // Only the "body" of the toast should fill the available space.
      alignSelf: "center",
      paddingInlineStart: 2,
      paddingInlineEnd: 3
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

/**
 * @see https://experience.indeed.design/components/ids/toast
 */
const Toast = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    children,
    dismissProps = {
      "aria-label": "Close"
    },
    icon,
    onDismiss,
    status = "info",
    type = "polite",
    ...props
  } = _ref2;
  const Icon = icon === undefined ? icons[status] : icon;
  const AnnounceableContent = jsx(StyledNotificationContent, {
    sx: {
      paddingBlockStart: 0,
      paddingBlockEnd: 0
    }
  }, children);
  const ToastContent = type ? jsx(LiveRegion, {
    type: type
  }, AnnounceableContent) : AnnounceableContent;
  return jsx(StyledToast, _extends({
    ref: ref,
    status: status,
    role: "group"
  }, props), Icon && jsx(StyledNotificationIcon, {
    sx: {
      display: "flex",
      marginBlockStart: 0,
      paddingBlockStart: 0,
      paddingInlineEnd: 0
    }
  }, Icon), jsx(StyledNotificationBody, {
    sx: {
      marginBlockStart: "0.125rem"
    }
  }, ToastContent), onDismiss && jsx(Button, _extends({
    iconOnly: true,
    sx: {
      flex: "0 0 auto",
      marginBlockStart: "-sc2",
      marginInlineEnd: "-sc2",
      marginBlockEnd: "-sc2"
    },
    variant: "tertiary",
    size: "sm",
    onClick: onDismiss
  }, dismissProps), jsx(Close, {
    "aria-hidden": true
  })));
});
const TOAST_STATUSES = Object.keys(statuses);
Toast.displayName = "Toast";

export { TOAST_STATUSES, Toast, NotificationTitle as ToastTitle };
